import React from "react";

const Shops = () => {
  return (
    <div>
      <h1>hello shops</h1>
    </div>
  );
};

export default Shops;
